import { hasKeyPrefix } from '.'

const BASE64_PATTERN = /^[A-Za-z0-9+/]+={0,2}$/
const MIN_KEY_BASE64_LENGTH = 40
const MIN_CIPHERTEXT_LENGTH = 1
const IV_BASE64_LENGTH = 16
const IV_DECODED_BYTE_LENGTH = 12

export const isValidEncryptionKey = (value: string): boolean => {
  if (!hasKeyPrefix(value)) return false

  const rawBase64 = value.slice(3)
  if (rawBase64.length < MIN_KEY_BASE64_LENGTH) return false

  return BASE64_PATTERN.test(rawBase64)
}

export const isValidEncryptedPayload = (value: unknown): boolean => {
  if (typeof value !== 'object' || value === null) return false

  const record = value as Record<string, unknown>

  if (record['encrypted'] !== true) return false
  if (record['algorithm'] !== 'AES-256-GCM') return false
  if (typeof record['keyVersion'] !== 'number' || record['keyVersion'] < 1) return false
  if (
    typeof record['ciphertext'] !== 'string' ||
    record['ciphertext'].length < MIN_CIPHERTEXT_LENGTH
  )
    return false
  if (typeof record['iv'] !== 'string' || record['iv'].length < IV_BASE64_LENGTH) return false

  try {
    const decodedIv = atob(record['iv'])
    if (decodedIv.length !== IV_DECODED_BYTE_LENGTH) return false
  } catch {
    return false
  }

  return true
}

export const isValidKeyVersion = (version: unknown): version is number => {
  return typeof version === 'number' && Number.isInteger(version) && version >= 1
}
